import { render, staticRenderFns } from "./DigitCouplesPreview.vue?vue&type=template&id=586573de&lang=pug&"
import script from "./DigitCouplesPreview.vue?vue&type=script&lang=js&"
export * from "./DigitCouplesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports